import flowSchema from '@feedyou-ai/feedbot-schema/schema/botFlow.json'
import { StepNlpSettings } from '@feedyou/schema'
import produce from 'immer'

import { useFeature } from '../../../../store/features'
import { OnFormDataChange } from '../../hooks'
import { useDefaultPrompts } from '../../../../features/hostingVersions/hooks/useDefaultPrompts'

export function useSchemas(formData: StepNlpSettings = {}) {
  const hideLlmConfigs = !useFeature('NLP_INTENTS_WITH_DESCRIPTION')
  const baseSchema = flowSchema.properties.nlp.properties.stepNlp ?? {}
  const defaultPrompts = useDefaultPrompts()

  const schema = produce(baseSchema, draft => {
    if (!formData.enabled) {
      return {
        type: 'object',
        properties: {
          enabled: {
            type: 'boolean',
            title: 'Step NLP enabled'
          }
        }
      } as any
    }

    if (hideLlmConfigs) {
      const providerSchema = draft.properties.configurations.items.properties.provider
      providerSchema.anyOf = providerSchema.anyOf.filter(
        item => item.properties.type.const !== 'llm-classifier'
      )
    }
  })

  const uiSchema = {
    'ui:label': false,
    defaultConfigurationId: {
      'ui:widget': 'StepNlpConfigSelectWidget',
      'ui:options': {
        mode: 'default',
        liveConfigurations: formData.configurations?.filter(config => !!config.id)
      }
    },
    configurations: {
      items: {
        'ui:title': false,
        'ui:order': ['id', 'provider', '*'],

        provider: {
          type: { 'ui:widget': 'hidden' },
          prompt: {
            'ui:widget': 'DefaultPromptEditorWidget',
            initialRowsCount: 12,
            defaultPrompt: defaultPrompts?.llmClassifierText
          },
          stepIntentLlmChatService: {
            'ui:widget': 'BotCloudServiceSelectWidget',
            kind: 'llm-chat',
            action: 'Step NLP classifier'
          }
        }
      }
    }
  }

  return { schema, uiSchema }
}

type InjectorParams<D extends StepNlpSettings> = {
  initialFormData: D
  formData: D
  onFormDataChange: OnFormDataChange<D>
}
